import { render } from "./Stats.vue?vue&type=template&id=5ccce191&scoped=true"
import script from "./Stats.vue?vue&type=script&lang=js"
export * from "./Stats.vue?vue&type=script&lang=js"

import "./Stats.vue?vue&type=style&index=0&id=5ccce191&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5ccce191"

export default script